<template>
  <div class="slide zoom" v-bind="$attrs" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide7_1',
  data() {
    return {
      parallax: [
        {
          start: 4800,
          end: 5300,
          fromStyle: { transform: 'translateY(-1400px)' },
          toStyle: { transform: 'translateY(210px)' },
          easing: 'linear'
        },
        {
          start: 6800,
          end: 7400,
          fromStyle: { transform: 'translateY(210px)' },
          toStyle: { transform: 'translateY(1800px)' },
          easing: 'linear'
        }
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/07_Photo_1.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 450px;
    height: 500px;
    left: -230px;
    top: calc(50% - 520px);
    transition: 0.6s;
    z-index: 2;
    @media(max-width: 600px) {
      width: 200px;
      left: -100px;
      top: calc(50% - 490px);
    }
}
</style>
